import { useState } from 'react';
import { faqItems } from '@/mocks/gossipContent';
import Reveal from '@/components/base/Reveal';

const TRUST_POINTS = [
  { icon: 'ri-file-list-3-line', title: '素材标注来源', desc: '录音、截图、录屏一律标明引用源数量，观点与事实分开呈现。' },
  { icon: 'ri-refresh-line', title: '状态实时更新', desc: '发酵中、已回应、已反转、冷处理四态实时打标，反转即更正。' },
  { icon: 'ri-verified-badge-line', title: '先验真、再定性', desc: '存疑素材一律标“待核实”，不预判、不标题党式定性。' },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number>(1);

  return (
    <section id="faq" className="bg-background-50 border-t border-background-200/70">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* 左：信任点 */}
          <Reveal className="lg:col-span-5">
            <div className="flex items-center gap-2 text-xs">
              <span className="font-heading text-primary-600 tracking-widest">CH.06</span>
              <span className="h-px w-8 bg-background-300" />
              <span className="text-foreground-500">防迷路 · 信任说明</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold mt-3 tracking-tight leading-tight">
              吃瓜不迷路，
              <br />
              先看懂<span className="text-primary-600">红黑料的规矩</span>
            </h2>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
              负面事件与黑料曝光天生带着情绪，也最容易“先入为主”。所以我们给自己立了几条底线，也把答案放到明面上。
            </p>

            <div className="mt-6 space-y-3">
              {TRUST_POINTS.map((p) => (
                <div key={p.title} className="flex gap-3 rounded-md bg-background-100 border border-background-200/70 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={`${p.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-[15px]">{p.title}</h3>
                    <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          {/* 右：FAQ 手风琴 */}
          <div className="lg:col-span-7">
            <div className="space-y-3">
              {faqItems.map((f, idx) => {
                const isOpen = open === f.id;
                return (
                  <Reveal key={f.id} delay={idx * 40}>
                    <div className={`overflow-hidden rounded-md border transition-colors ${isOpen ? 'border-primary-300 bg-background-100' : 'border-background-200/80 bg-background-100/60'}`}>
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? -1 : f.id)}
                        className="flex w-full items-center gap-3 px-4 md:px-5 py-4 text-left cursor-pointer"
                      >
                        <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-medium ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'}`}>
                          {f.id}
                        </span>
                        <h3 className="flex-1 font-heading text-[15px] font-semibold leading-snug">{f.q}</h3>
                        <i className={`ri-add-line text-xl text-foreground-500 w-5 h-5 flex items-center justify-center transition-transform ${isOpen ? 'rotate-45' : ''}`} />
                      </button>
                      {isOpen && (
                        <div className="px-4 md:px-5 pb-4 md:pl-14">
                          <p className="text-sm text-foreground-700 leading-relaxed">{f.a}</p>
                        </div>
                      )}
                    </div>
                  </Reveal>
                );
              })}
            </div>

            <Reveal>
              <div className="mt-5 rounded-md border border-primary-200 bg-primary-50/60 px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3">
                <div className="flex-1">
                  <div className="text-sm font-medium text-primary-900">还有疑问，或对某条存疑素材有异议？</div>
                  <div className="text-xs text-primary-700 mt-0.5">资料组对存疑信息一律“先验真、再定性”，欢迎提出补充证据。</div>
                </div>
                <a href="#top" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-background-50 px-4 py-2 text-sm hover:bg-primary-600 transition-colors">
                  回到封面
                  <i className="ri-arrow-up-line w-4 h-4 flex items-center justify-center" />
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}